import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  createWhatsappCompaign(data) {
    // eslint-disable-next-line no-undef
    return axios.post(`${this.url}/create_whatsapp_campaign`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  sendToSingleContact(accountId, data) {
    // eslint-disable-next-line no-undef
    return axios.post(
      `/api/v1/accounts/${accountId}/campaigns/send_to_single_contact`,
      data
    );
  }
}

export default new CampaignsAPI();
